@if((isLoading$ | async) && spinnerType() === 'global') {
<div class="overlay">
  <span class="loader"></span>
</div>
}

@if((isLoadingUserData$ | async) && spinnerType() === 'userData') {
<section class="bg-layer-carousel background-pleca">
  <div class="pleca-hover pe-3 ">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="">
            <div class="progress w-100" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 75%"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}